<template>
    <nav v-if="totalPages > 1" class="w-100 margin-b-3">
        <!-- MOBILE PAGINATION -->
        <div class="mobile-pagination flex justify-center align-center gap-2">
            <button
                @click="goToPage(currentPage - 1)"
                :disabled="currentPage === 1"
                class="text-m text-color-strong flex align-center"
            >
                <img src="/assets/icons/chevron-left.svg" alt="chevron-left" />
            </button>
            <span class="text-sm">{{ currentPage }} of {{ totalPages }}</span>
            <button
                @click="goToPage(currentPage + 1)"
                :disabled="currentPage === totalPages"
                class="text-m text-color-strong flex align-center"
            >
                <img src="/assets/icons/chevron-right.svg" alt="chevron-right" />
            </button>
        </div>
        <!-- DESKTOP PAGINATION -->
        <div class="desktop-pagination flex justify-center align-center gap-2">
            <a
                @click="goToPage(currentPage - 1)"
                :disabled="currentPage === 1"
                class="text-m text-color-strong flex align-center gap-1 padding-r-1 cursor-pointer"
            >
                <img src="/assets/icons/chevron-left.svg" alt="chevron-left" />
                Previous
            </a>

            <template v-for="page in paginationRange" :key="page.key">
        <span
            v-if="page.type === 'ellipsis'"
            class="flex padding-h-1 border-box align-center text-sm text-color-weak"
        >
          …
        </span>

                <a
                    v-else
                    @click="goToPage(page.number)"
                    :class="page.number === currentPage ? 'bordered text-color-strong pagination-control-button' : 'text-color-strong pagination-control-button'"
                >
                  <span class="padding-h-1 border-box text-sm">
                    {{ page.number }}
                  </span>
                </a>
            </template>

            <a
                @click="goToPage(currentPage + 1)"
                :disabled="currentPage === totalPages"
                class="text-m text-color-strong flex align-center gap-1 padding-l-1 cursor-pointer"
            >
                Next
                <img src="/assets/icons/chevron-right.svg" alt="chevron-right" />
            </a>
        </div>
    </nav>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    currentPage: { type: Number, required: true },
    totalPages: { type: Number, required: true },
})

const emit = defineEmits(['change-page'])

const goToPage = (page) => {
    if (page >= 1 && page <= props.totalPages) {
        emit('change-page', page)
    }
}

const paginationRange = computed(() => {
    const range = []
    let lastAdded = 0

    for (let i = 1; i <= props.totalPages; i++) {
        if (
            i === 1 ||
            i === props.totalPages ||
            (i >= props.currentPage - 1 && i <= props.currentPage + 1)
        ) {
            if (lastAdded && i > lastAdded + 1) {
                range.push({ type: 'ellipsis', key: `e-${i}` })
            }
            range.push({ type: 'page', number: i, key: `p-${i}` })
            lastAdded = i
        }
    }

    return range
})
</script>
